import { API_URL_V1, API_URL_V2 } from '@/constants/ApiSetting';
import axios from 'axios';
import { store } from '../NextApp';
import { handleSessionExpired, isSessionInvalidResponse } from '@/util/sessionExpiredHandler';
import { useApiHealthStore } from '@/zusttandStore/apiHealth.store';

/** 30-second timeout — covers slow hotel network without hanging forever */
const API_TIMEOUT = 30_000;

const sharedHeaders = {
  'Content-Type': 'application/json',
  'x-api-key': process.env.REACT_APP_API_PMS_KEY,
};

// ✅ Create instance WITHOUT token in headers
const baseUrl = axios.create({
  baseURL: API_URL_V1,
  timeout: API_TIMEOUT,
  headers: sharedHeaders,
});

const baseUrlV2 = axios.create({
  baseURL: API_URL_V2,
  timeout: API_TIMEOUT,
  headers: sharedHeaders,
});

const localServiceUrl = axios.create({
  baseURL: process.env.REACT_APP_ISSUE_CARD_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

function addSharedInterceptors(instance: import('axios').AxiosInstance) {
  instance.interceptors.request.use(
    (config) => {
      const token =
        localStorage.getItem('access_token') ||
        (
          JSON.parse(localStorage.getItem('fromas-state') || '{}') as {
            auth: { authUser: { access_token: string } };
          }
        )?.auth?.authUser?.access_token;
      if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
        config.headers['x-api-key'] = process?.env?.REACT_APP_API_PMS_KEY;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  instance.interceptors.response.use(
    (response) => {
      useApiHealthStore.getState().reportSuccess();
      return response;
    },
    (error) => {
      const status: number | undefined = error.response?.status;
      const data = error.response?.data;

      if (!error.response || error.code === 'ECONNABORTED' || error.code === 'ERR_NETWORK') {
        useApiHealthStore.getState().reportFailure('network');
      } else if (status !== undefined && status >= 500) {
        useApiHealthStore.getState().reportFailure('server');
      } else {
        useApiHealthStore.getState().reportSuccess();
      }

      if (status !== undefined && isSessionInvalidResponse(status, data)) {
        handleSessionExpired(store, data?.message);
      }

      return Promise.reject(error);
    }
  );
}

// ✅ Add request interceptor to inject FRESH token on every request
addSharedInterceptors(baseUrl);
addSharedInterceptors(baseUrlV2);

localServiceUrl.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token && config.headers) {
      console.log('token', token);
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


localServiceUrl.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const data = error.response?.data;
    if (status !== undefined && isSessionInvalidResponse(status, data)) {
      handleSessionExpired(store, data?.message);
    }
    return Promise.reject(error);
  }
);

const ocrServiceUrl = axios.create({
  baseURL: process.env.REACT_APP_OCR_API_SERVICE,
  headers: {
    'X-API-Key': process.env.REACT_APP_OCR_API_SERVICE_TOKEN,
  },
});

export { baseUrl, baseUrlV2, localServiceUrl, ocrServiceUrl };
